import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchForm from '@/components/SearchForm';
import NoData from '@/components/NoData/NoData';
import { valsubstr32addbr } from '@/utils/index';
export default {
  components: {
    SearchForm: SearchForm,
    NoData: NoData
  },
  data: function data() {
    return {
      searchFormData: [{
        title: '系统名称',
        key: 'sysName',
        placeholder: '请选择系统名称',
        type: 'selectsystem',
        selectData: [],
        selectedArr: [],
        multiple: false
      }, {
        title: '时间',
        key: 'date',
        placeholder: '请选择(当月/当季/上季度)',
        type: 'date2',
        value: [],
        selectData: [],
        selectedArr: []
      }, {
        title: '模块名称',
        key: 'modulename',
        placeholder: '请输入模块名称',
        type: 'input',
        value: null
      }, {
        title: '描述',
        key: 'describe',
        placeholder: '请输入描述',
        type: 'input',
        value: null
      }, {
        title: '请求方式',
        key: 'selectrequest',
        placeholder: '请选择请求方式',
        type: 'select',
        selectData: [],
        selectedArr: [],
        multiple: false
      }],
      LogData: [],
      btnType: 'search,reset',
      filtratedata: {
        pageNum: 1,
        pageSize: 10,
        description: '',
        module: '',
        operation: '',
        publishDateEnd: '',
        publishDateStart: '',
        systemId: ''
      },
      dellist: [],
      totalrecord: 0,
      loading: false,
      tableheight: 512,
      showdetail: false,
      paramdetail: ''
    };
  },
  created: function created() {
    this.getsystemlist();
    this.getrequesttype();
    this.getlogList();
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      this.tableheight = window.innerHeight - 332;

      // 监听窗口大小变化
      var self = this;
      window.onresize = function () {
        self.tableheight = window.innerHeight - 332;
      };
    });
  },
  methods: {
    getlogList: function getlogList() {
      var _this = this;
      this.loading = true;
      this.$API.getRequest({
        url: '/platform/syslog/logList',
        data: this.filtratedata
      }).then(function (res) {
        _this.loading = false;
        if (res.code === '0000000000') {
          _this.LogData = res.result.records;
          _this.totalrecord = res.result.total;
        }
      });
    },
    getsystemlist: function getsystemlist() {
      var _this2 = this;
      this.$API.getRequest({
        url: '/platform/systemInner/list'
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this2.searchFormData[0].selectData = res.result.records;
        }
      });
    },
    getrequesttype: function getrequesttype() {
      var _this3 = this;
      this.$API.getRequest({
        url: '/platform/syslog/operation'
      }).then(function (res) {
        if (res.code === '0000000000') {
          // eslint-disable-next-line array-callback-return
          res.result.filter(function (item) {
            var selectvalue = {
              value: item.key,
              label: item.key
            };
            _this3.searchFormData[4].selectData.push(selectvalue);
          });
        }
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.filtratedata.pageNum = val;
      this.getlogList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.filtratedata.pageSize = val;
      this.getlogList();
    },
    searchForm: function searchForm(obj) {
      this.filtratedata.systemId = obj[0].selectedArr;
      this.filtratedata.description = obj[3].value;
      this.filtratedata.module = obj[2].value;
      this.filtratedata.operation = obj[4].selectedArr;
      this.filtratedata.publishDateEnd = obj[1].value ? obj[1].value[1] : '';
      this.filtratedata.publishDateStart = obj[1].value ? obj[1].value[0] : '';
      // this.filtratedata.systemId = obj[0].value;
      this.filtratedata.pageNum = 1;
      this.getlogList();
    },
    resetForm: function resetForm() {
      this.searchFormData[0].selectedArr = '';
      this.searchFormData[1].value = [];
      this.searchFormData[4].selectedArr = '';
      this.searchFormData[2].value = '';
      this.searchFormData[3].value = '';
      this.filtratedata.systemId = '';
      this.filtratedata.description = '';
      this.filtratedata.module = '';
      this.filtratedata.operation = '';
      this.filtratedata.publishDateEnd = '';
      this.filtratedata.publishDateStart = '';
      this.filtratedata.pageNum = 1;
      this.getlogList();
    },
    // 查看详细参数
    watchdetail: function watchdetail(detailpram) {
      this.showdetail = true;
      this.paramdetail = detailpram;
    },
    // tooltips过长换行(length 32换行)
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    headerdragend: function headerdragend(newWidth, oldWidth, column) {
      if (newWidth < column.minWidth) {
        column.width = column.minWidth;
      }
    }
  }
};